const getPublicDownloadUrl = (filename) => {
  if (!filename) return "";
  const pathname = filename.split("?")[0];
  return `${
    process.env.REACT_APP_EMULATOR_ENABLE === "true"
      ? "http://localhost:9199"
      : "https://firebasestorage.googleapis.com"
  }/v0/b/${
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
  }/o/${encodeURIComponent(pathname)}?alt=media`;
};
 
export function getCDNPublicAvatarUrl(path, dim='512') {
  if (!(path?.includes("creators"))) return "";
  let normalizedPath = path;
  normalizedPath = normalizedPath.split("?")[0];

  // Replace 'picture.EXT' with 'picture_DIM.EXT', keeping the extension
  normalizedPath = normalizedPath.replace(/picture\.([a-zA-Z0-9]+)$/, `picture_${dim}.$1`);

  // Only return CDN url if the transformation actually occurred (file name changed)
  if (!normalizedPath.includes(`picture_${dim}.`)) {
    return "";
  }

  return `https://stream-cdn.nightco.io/${normalizedPath}`;
}

export function getStreamCDNPublicUrl(path) {
  if (!path) return null;
  return `https://stream-cdn.nightco.io/${path.startsWith("/") ? path.slice(1) : path}`;
}
export function getStreamProtectedCDNPublicUrl(path) {
  if (!path) return null;
  return `https://protected-cdn.nightco.io/${path.startsWith("/") ? path.slice(1) : path}`;
}

export default getPublicDownloadUrl;
